export class ColorModel {
    constructor(public Name: string, public Color: string, public Id?: string) {

    }
}